import { Input, ChakraProps } from "@chakra-ui/react";
import { Path, useFormContext } from "react-hook-form";
import { CheckmarkWrapper } from "./CheckmarkWrapper";
import { useTranslatedString } from "../../i18n/hooks";
import { FormErrorMessageI18n } from "../FormErrorMessageI18n/FormErrorMessageI18n";
import { FormLabel, FormControl } from "../forms";
import type { TypeOf, ZodType } from "zod";

type EmailInputProps<FormSchema extends ZodType> = {
	name: Path<TypeOf<FormSchema>>;
} & ChakraProps;

export const EmailInput = <FormSchema extends ZodType>({
	name,
	...rest
}: EmailInputProps<FormSchema>) => {
	const {
		control,
		register,
		formState: { errors },
	} = useFormContext<TypeOf<FormSchema>>();

	const t = useTranslatedString();

	if (typeof name !== "string") {
		return null;
	}

	return (
		<FormControl isInvalid={Boolean(errors[name])} {...rest}>
			<FormLabel>{t("login.email")}</FormLabel>
			<CheckmarkWrapper control={control} formKey={name}>
				<Input
					type="email"
					placeholder={t("emailInput.placeholder")}
					{...register(name)}
				/>
			</CheckmarkWrapper>
			<FormErrorMessageI18n message={errors[name]?.message?.toString()} />
		</FormControl>
	);
};

// 🔬 TBD: Please evaluate
